module.exports = __webpack_public_path__ + "static/media/back.815f323c.png";